import Collapsable from "../lib/Collapsable";

const state = {
  elements: {},
  collasables: [],
  isOpen: false,
};

const init = () => (
  cacheElements(),
  initCollapsables()
);

const ACTIVATE_KEYS = ['Enter', ' ', 'Spacebar'];

const initCollapsables = () => {
  state.elements.collaspsableLinks?.forEach(item => {
    const collapsableContainer = item.querySelector('.menu-drawer__menu-collapsable-wrapper')
    const collapsableContent = item.querySelector('.menu-drawer__menu--item-content');
    const collapsableIToggler = item.querySelector('.menu-drawer__menu-collapsable-icons');
    const behaviour = collapsableContainer.dataset?.behaviour;
    if (!collapsableContent) return;
    // In 'collapse' the whole row is the click target; in 'link' the row holds a
    // link, so only the +/- icon toggles. The Liquid puts role="button" and
    // aria-expanded/aria-controls on whichever one that is, so the accessible
    // control and the pointer target are always the same element.
    const toggler = behaviour === 'collapse' ? collapsableContainer : collapsableIToggler;
    const collapsable = new Collapsable({
      element: collapsableContent,
      toggler,
      // Mirror the open state onto the role="button" toggle's aria-expanded.
      ariaController: toggler,
      openClass: 'accordion-c--open',
      container: collapsableContainer,
      resetMedia: '(min-width: 1140px)',
      defaultHeight: 'auto'
    });
    // The toggle is a role="button" element (not a native <button>, which the
    // header-drawer's bindEvents would treat as a close button) — so add
    // keyboard activation ourselves. Mouse click is handled by Collapsable.
    toggler?.addEventListener('keydown', (e) => {
      if (e.target !== toggler) return; // ignore keys from nested controls
      if (!ACTIVATE_KEYS.includes(e.key)) return;
      e.preventDefault();
      collapsable.toggle();
    });
    state.collasables.push(collapsable);
  });
};

const cacheElements = () => {
  const drawerContainer = document.getElementById('menu-drawer');
  if (!drawerContainer) return;
  state.elements = {
    collaspsableLinks: Array.from(drawerContainer.querySelectorAll('.menu-drawer__menu--item-collapsable')),
  };
};

export default init;
